<div
  class="tw--m-4 tw-flex tw-min-h-[calc(100%+2rem)] tw-w-[calc(100%+2rem)] tw-bg-color-surface-page tw-p-4 sm:tw-m-0 sm:tw--mt-2 sm:tw-min-h-[calc(100dvh_-_var(--app-menu-height,0px))] sm:tw-w-full sm:tw-p-0"
>
  <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-6">
    <div
      class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-py-4 lg:tw-gap-2"
    >
      <span class="tw-whitespace-nowrap tw-text-2xl tw-font-medium">
        {{ "symbols" | i18n }}
      </span>

      <div
        class="tw-relative tw-order-2 tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-end lg:tw-order-3 lg:tw-basis-full"
      >
        <div
          appGlossScroll
          #groupStatsScroll
          class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3 lg:tw-gap-2 tw-overflow-x-auto tw-scroll-smooth tw-px-2 tw--mx-2 tw-py-2 tw--my-2 auto-hide-scrollbar"
          (scroll)="updateGroupStatsScrollArrows()"
        >
          @for (tile of groupTotals(); track tile.group) {
            <div
              class="tw-flex tw-shrink-0 tw-flex-col tw-gap-1 tw-min-w-[110px] tw-px-4 tw-py-3 lg:tw-px-3 lg:tw-py-2 tw-rounded-xl tw-bg-dt-surface-input tw-shadow-elevation-card"
            >
              <div class="tw-flex tw-items-center tw-gap-1.5">
                <icon [name]="tile.icon" [size]="4" [currentColor]="'dt-custom-teal-11'"></icon>
                <span
                  class="tw-text-xs tw-font-semibold tw-uppercase tw-text-color-text-default tw-whitespace-nowrap"
                >
                  {{ tile.labelKey | i18n }}
                </span>
                <span class="tw-text-xs tw-text-color-text-secondary">{{ tile.count }}</span>
              </div>
              <span
                class="tw-text-lg lg:tw-text-sm tw-font-semibold tw-whitespace-nowrap tw-text-color-text-default"
              >
                {{ tile.value | macroNumber }}
              </span>
              <span class="tw-text-xs tw-text-color-text-secondary tw-whitespace-nowrap">
                {{ "totalValueOfAssets" | i18n }}
              </span>
            </div>
          }
        </div>

        @if (canScrollGroupStatsLeft()) {
          <button
            type="button"
            aria-label="Scroll left"
            class="tw-flex tw-absolute tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-input tw-shadow-elevation-card"
            (click)="scrollGroupStats(-1)"
          >
            <icon name="left-arrow" [size]="4"></icon>
          </button>
        }
        @if (canScrollGroupStatsRight()) {
          <button
            type="button"
            aria-label="Scroll right"
            class="tw-flex tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-dt-surface-input tw-shadow-elevation-card"
            (click)="scrollGroupStats(1)"
          >
            <icon name="right-arrow" [size]="4"></icon>
          </button>
        }
      </div>

      <app-signal-glow-wrapper
        class="tw-order-3 tw-shrink-0 lg:tw-order-2"
        adjustmentClasses="tw-rounded-2xl"
      >
        <!-- Plain button, not app-gloss-button: that component always renders text before
             the icon with no way to hide just the text at a breakpoint. -->
        <button
          type="button"
          class="border-gradient-teal tw-shadow-manage-accounts tw-flex tw-h-10 tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-full tw-bg-dt-custom-teal-11 tw-px-4 sm:tw-px-6"
          (click)="handleAddSymbolClick()"
        >
          <icon name="add" [size]="4" [currentColor]="'white'"></icon>
          <span class="tw-text-sm tw-font-medium tw-text-white sm:tw-hidden">{{
            "addSymbol" | i18n
          }}</span>
        </button>
      </app-signal-glow-wrapper>
    </div>

    <div
      class="tw-grid tw-grid-cols-[2fr_3fr] lg:tw-grid-cols-1 sm:tw-flex tw-h-full tw-w-full tw-justify-between tw-gap-2"
    >
      <div
        id="symbols-table"
        class="tw-flex tw-flex-col tw-gap-4 tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-page tw-px-4 sm:tw-px-2 gutter-bleed-column sm:tw-flex-1"
      >
        <!-- Below 640px the column's 16px is split 8 + 8 (column + search wrapper / scroller): the
             scroller is overflow-y-auto there, which clips sideways too, so its own sm:px-2 is the
             room the cards' shadows need. -->
        <div class="sm:tw-px-2">
          <app-search-input
            class="tw-shrink-0"
            [placeholder]="'searchSymbol' | i18n"
            [value]="searchQuery()"
            (valueChange)="searchQuery.set($event)"
          ></app-search-input>
        </div>

        <div
          appGlossScroll
          class="tw-flex tw-h-auto tw-w-full tw-max-w-full tw-flex-col tw-items-start tw-justify-start tw-gap-4 tw-self-stretch tw-py-2 sm:tw-h-auto sm:tw-w-full sm:tw-overflow-y-auto sm:tw-px-2"
        >
          @for (groupBlock of groupedFilteredData(); track groupBlock.group) {
            <div class="tw-flex tw-w-full tw-items-center tw-gap-1.5">
              <span
                class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary tw-whitespace-nowrap"
              >
                {{ groupBlock.labelKey | i18n }}
              </span>
              <div class="tw-h-px tw-flex-1 tw-bg-color-border-subtle"></div>
            </div>
            @for (symbolItem of groupBlock.items; track symbolItem.id) {
              <div
                role="button"
                tabindex="0"
                class="tw-box-border tw-flex tw-w-full tw-items-center tw-gap-4 tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-card tw-p-4 tw-text-left tw-transition-colors"
                [ngClass]="{
                  'tw-shadow-accounts': selectedSymbol()?.code !== symbolItem.code,
                  'card-selected': selectedSymbol()?.code === symbolItem.code,
                }"
                (click)="table.onRowClicked(symbolItem.rawSymbol)"
                (keydown.enter)="table.onRowClicked(symbolItem.rawSymbol)"
                (keydown.space)="table.onRowClicked(symbolItem.rawSymbol); $event.preventDefault()"
              >
                <div
                  #rowContent
                  class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-between tw-gap-x-3 tw-overflow-hidden"
                >
                  <div
                    class="tw-flex tw-flex-1 tw-flex-col tw-gap-1"
                    [ngClass]="
                      compactRateEquationIds().has(symbolItem.id)
                        ? 'tw-min-w-[40px]'
                        : 'tw-min-w-[96px]'
                    "
                  >
                    <span
                      [attr.title]="symbolItem.code"
                      class="card-selected-name tw-min-w-0 tw-truncate tw-text-sm tw-font-semibold tw-leading-[100%] tw-tracking-[0] tw-text-color-text-default tw-text-left tw-align-middle"
                    >
                      {{ symbolItem.code }}
                    </span>
                    @if (symbolItem.description) {
                      <span
                        class="tw-truncate tw-text-xs tw-font-normal tw-text-color-text-secondary"
                      >
                        {{ symbolItem.description }}
                      </span>
                    }
                  </div>

                  @if (showRateEquation(symbolItem, groupBlock.group)) {
                    <div
                      #rateEquationArea
                      [attr.data-symbol-id]="symbolItem.id"
                      class="tw-items-center tw-whitespace-nowrap"
                      [ngClass]="
                        compactRateEquationIds().has(symbolItem.id)
                          ? rateEquationCompactClasses
                          : rateEquationDefaultClasses
                      "
                    >
                      <div
                        class="tw-flex tw-items-end tw-gap-1 tw-col-start-1 tw-row-start-1 tw-justify-self-end"
                        data-rate-col
                      >
                        <span
                          data-rate-num
                          class="tw-font-D-DIN-PRO tw-text-sm tw-font-semibold tw-text-color-text-secondary"
                        >
                          1.00
                        </span>
                        <span
                          class="tw-text-[10px] tw-font-medium tw-text-color-text-tertiary tw-uppercase"
                        >
                          {{ symbolItem.code }}
                        </span>
                      </div>

                      <div
                        class="tw-flex tw-items-center tw-gap-0.5 tw-whitespace-nowrap tw-rounded-full tw-bg-color-surface-input tw-px-2 tw-py-1 tw-text-color-text-tertiary tw-col-start-2 tw-row-start-1 tw-row-span-2 tw-self-center"
                      >
                        <span class="tw-text-[8px] tw-font-semibold">&#64;</span>
                        <span class="tw-font-D-DIN-PRO tw-text-[10px] tw-font-semibold">
                          @if (isCompactValue(symbolItem.rawSymbol?.c_asOf?.rate)) {
                            1:{{ symbolItem.rawSymbol?.c_asOf?.rate | macroNumber }}
                          } @else {
                            1:{{ (symbolItem.rawSymbol?.c_asOf?.rate | number: "1.0-2") || "0.00" }}
                          }
                        </span>
                      </div>

                      <div
                        class="tw-flex tw-items-baseline tw-gap-1 tw-col-start-1 tw-row-start-2 tw-justify-self-end"
                        data-rate-col
                      >
                        <span
                          data-rate-num
                          class="tw-font-D-DIN-PRO tw-text-lg tw-font-semibold tw-text-color-text-default"
                        >
                          @if (isCompactValue(symbolItem.rawSymbol?.c_asOf?.rate)) {
                            {{ symbolItem.rawSymbol?.c_asOf?.rate | macroNumber }}
                          } @else {
                            {{ (symbolItem.rawSymbol?.c_asOf?.rate | number: "1.0-2") || "0.00" }}
                          }
                        </span>
                        <span
                          class="tw-text-[10px] tw-font-medium tw-text-color-text-tertiary tw-uppercase"
                        >
                          {{ symbolItem.rawSymbol?.c_asOf?.symbol }}
                        </span>
                      </div>
                    </div>
                  } @else {
                    <div class="tw-flex tw-shrink-0 tw-items-baseline tw-gap-1 tw-text-right">
                      <span class="tw-text-sm tw-font-medium tw-text-color-text-default">
                        @if (isCompactValue(symbolItem.rawSymbol?.c_asOf?.rate)) {
                          {{ symbolItem.rawSymbol?.c_asOf?.rate | macroNumber }}
                        } @else {
                          {{ (symbolItem.rawSymbol?.c_asOf?.rate | number: "1.0-2") || "0.00" }}
                        }
                      </span>
                      <span
                        class="tw-text-xs tw-font-medium tw-text-color-text-tertiary tw-uppercase"
                      >
                        {{ symbolItem.rawSymbol?.c_asOf?.symbol }}
                      </span>
                    </div>
                  }
                </div>

                <div class="tw-shrink-0 tw-text-color-icon-default">
                  <icon
                    [name]="'right-arrow'"
                    [size]="5"
                    [currentColor]="'color-icon-default'"
                  ></icon>
                </div>
              </div>
            }
          }
        </div>
      </div>

      @if (selectedSymbol()) {
        <div
          appGlossScroll
          class="tw-overflow-hidden tw-rounded-2xl tw-bg-color-surface-card tw-shadow-elevation-card tw-p-5 lg:tw-shadow-none lg:tw-p-3 lg:tw-fixed lg:tw-left-0 lg:tw-top-0 lg:tw-bottom-0 lg:tw-w-full lg:tw-overflow-auto lg:tw-bg-color-surface-page lg:tw-rounded-none lg:tw-pb-[calc(var(--app-menu-height,0px)+0.75rem)] lg:tw-z-50"
        >
          <app-symbol-details
            [(symbol)]="table.selectedSymbol"
            (onSymbolUpdate)="onSymbolUpdated($event)"
            (onBackClicked)="closeSymbolDetails()"
          ></app-symbol-details>
        </div>
      }
    </div>
  </div>
</div>
